
import { Component, effect, EventEmitter, input, Output } from '@angular/core';
import { TtmImage } from '../../classes/ttmimage';
import {CodaltComponent} from '../codalt/codalt.component';

@Component({
    selector: 'app-image-drawer',
    templateUrl: './image-drawer.component.html',
    styleUrl: './image-drawer.component.scss',
})
export class ImageDrawerComponent extends CodaltComponent{
    ttmImages = input<TtmImage[]>([]);
    currentImage = input<TtmImage | null>(null);
    ttmStatuses = input<any[]>([]);
    ttmImageDistance = input<Map<number, string>>(new Map());
    @Output() close = new EventEmitter<void>();
    @Output() imageChange = new EventEmitter<TtmImage>();
    @Output() openLocation = new EventEmitter<any>();
    currentIndex = 0;
    isAtPhotoLocation = false;

    constructor() {
        super();
        effect(() => {
            if (this.currentImage() && this.ttmImages().length) {
                const idx = this.ttmImages().findIndex(img => img.id === this.currentImage().id);
                if (idx !== -1) {
                    this.currentIndex = idx;
                    this.isAtPhotoLocation = false;
                }
            }
        });
    }

    previous() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.imageChange.emit(this.ttmImages()[this.currentIndex]);
        }
    }

    next() {
        if (this.currentIndex < this.ttmImages().length - 1) {
            this.currentIndex++;

            this.imageChange.emit(this.ttmImages()[this.currentIndex]);
        }
    }

    onOpenLocation() {
        const currentImage = this.ttmImages()[this.currentIndex];
        if (currentImage.location) {
            if (this.isAtPhotoLocation) {
                this.openLocation.emit(null);
                this.isAtPhotoLocation = false;
            } else {
                this.openLocation.emit(currentImage.location);
                this.isAtPhotoLocation = true;
            }
        }
    }
}
